exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "body {\n  margin: 0;\n  padding: 0;\n  font-family: \"Geogtq-Rg\", Helvetica, Arial, sans-serif;\n  overscroll-behavior-y: contain;\n}\n", ""]);

